import { consoleLogger } from '@shared/logging/consoleLogger';

export const deconstructUri = (uri: string) => {
  const urlArray = uri.split('://');
  if (!Array.isArray(urlArray) || urlArray.length !== 2) {
    consoleLogger.logError(`Incorrect URI provided: ${uri}`);
    return { protocol: null, domain: null, path: null };
  }

  const [protocol] = urlArray;
  const urnArray = urlArray[1].split('/');

  if (!Array.isArray(urnArray) || urnArray[0] === '') {
    consoleLogger.logError(`Incorrect URI provided: ${uri}`);
    return { protocol, domain: null, path: null };
  }

  const [domain] = urnArray;
  const path = urnArray[1] ? urnArray.slice(1).join('/') : null;

  return { protocol, domain, path };
};
